import { render, staticRenderFns } from "./Psd2Field.vue?vue&type=template&id=523a05ef&scoped=true&"
import script from "./Psd2Field.vue?vue&type=script&lang=js&"
export * from "./Psd2Field.vue?vue&type=script&lang=js&"
import style0 from "./Psd2Field.vue?vue&type=style&index=0&id=523a05ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a05ef",
  null
  
)

export default component.exports